$(document).ready(function() {
  console.log("Fullfillments App Working")
  console.log(meta.page.pageType);	

  var shop_name = 'qtse-fr.myshopify.com';
  var appurl = 'https://q-france.appshq.io/';
  $('form[action="/cart/add"]').prepend('<div class="stockloading loader"></div>');
  $('form[action="/cart/add"]').prepend('<style>.stockloading.loader{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-image: url(https://q-france.appshq.io/images/loading-gear.gif);background-repeat: no-repeat;background-position: center;z-index: 10;background-color: white; display:none;}form[action="/cart/add"]{position:relative;}</style>');

  $('form[action="/en/cart/add"]').prepend('<div class="stockloading loader"></div>');
  $('form[action="/en/cart/add"]').prepend('<style>.stockloading.loader{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-image: url(https://q-france.appshq.io/images/loading-gear.gif);background-repeat: no-repeat;background-position: center;z-index: 10;background-color: white; display:none;}form[action="/cart/add"]{position:relative;}</style>');

  $('.stockloading').show();
  var url = new URL(window.location.href);
  var c = url.searchParams.get("variant");
  console.log(c);


  //     function getShopDomain() {

  //         var a = document.getElementsByTagName('script');
  //         var b = a[0].src.substring(a[0].src.indexOf('shop=') + 5);
  //         return b;
  //     }
  //       var id = meta.product.id;


  console.log(shop_name);

  if (meta.page.pageType == 'product') {
    var selectedvar = (c != undefined) ? c : meta.product.variants[0].id;
    console.log(selectedvar);
    console.log(meta.product.id);
    var variant_quantity = document.getElementById('quantity').value;
    console.log(variant_quantity)

    $('.stockloading').show();
    $.ajax({
      url: appurl + "ajax_product_stock.php",
      type: "POST",
      data: { shop_name: shop_name, product_id: meta.product.id, variant_id: selectedvar,variant_quantity:variant_quantity },
      dataType: "json",
      success: function(response) {
        console.log(response);
        if (response.result == 'true'  && response.enable == 1) {


          if(response.tag !== ""){
            console.log("Tag Hy")

//             if(response.roll_quantity > 0 || response.tracking === false){


              if (response.meter_selected <= response.database_available) {
                $('.product-single__stock-note').show();
                $('input[name="button"]')[0].value="Ajouter au panier"
                $('input[name="button"]')[0].disabled = false
                $('.flits-wsl-btn').prop('disable', false);

                setTimeout(function() { $('.stockloading').hide(); }, 1000);

              }else{


                $('input[name="button"]')[0].value="stock épuisé"
                $('input[name="button"]')[0].disabled = true
                $('.flits-wsl-btn').hide();
                setTimeout(function() { $('.stockloading').hide(); }, 1000);
                //	$('.stockloading').hide();

              }




//             } else {

//               $('input[name="button"]')[0].value="stock épuisé"
//               $('input[name="button"]')[0].disabled = true
//               $('.flits-wsl-btn').hide();
//               setTimeout(function() { $('.stockloading').hide(); }, 1000);
//               //	$('.stockloading').hide();


//             }

          }else{
            console.log("Tag Nai Hy")
            setTimeout(function() { $('.stockloading').hide(); }, 1000);
            //	$('.stockloading').hide();

          }
          //   $('.stockloading').hide();




        }



      }

      ,
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);

      }
    });




    $(document).on('change', '.single-option-selector', function() {
      $('.stock_loading').show();
      document.getElementsByClassName('stockloading')[0].style.display = "block"

      console.log("change")
      $('.variant__button-label').removeClass("disabled");
      console.log("variant change detected");
      var change_url = new URL(window.location.href);
      var var_id = change_url.searchParams.get("variant");
      var selectedvars = (var_id != undefined) ? var_id : meta.product.variants[0].id;
      var variant_quantity = document.getElementById('quantity').value;
      console.log(variant_quantity)

      console.log(var_id);
      $.ajax({
        url: appurl + "ajax_product_stock.php",
        type: "POST",
        data: { shop_name: shop_name, product_id: meta.product.id,variant_id: selectedvars, page: "product-change",variant_quantity:variant_quantity },
        dataType: "json",
        success: function(response) {
          console.log(response);

          if (response.result == 'true') {
            $('form[action="/cart/add"]').prepend('<div class="stockloading loader"></div>');
            $('form[action="/cart/add"]').prepend('<style>.stockloading.loader{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-image: url(https://q-france.appshq.io/images/loading-gear.gif);background-repeat: no-repeat;background-position: center;z-index: 10;background-color: white; display:none;}form[action="/cart/add"]{position:relative;}</style>');

            $('form[action="/en/cart/add"] .product-single__add').before('<div class="stockloading loader"></div>');
            $('form[action="/en/cart/add"] .product-single__add').before('<style>.stockloading.loader{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-image: url(images/loading-gear.gif);background-repeat: no-repeat;background-position: center;background-color: white; display:none;}form[action="/cart/add"]{position:relative;}</style>');

            $('.stock_loading').show();
            document.getElementsByClassName('stockloading')[0].style.display = "block"


            if(response.tag !== ""){

//               if(response.roll_quantity > 0 || response.tracking === false){

                if (response.meter_selected <= response.database_available) {
                  $('.product-single__stock-note').show();
                  $('input[name="button"]')[0].value="Ajouter au panier"
                  $('input[name="button"]')[0].disabled = false
                  $('.flits-wsl-btn').prop('disable', false);

                  setTimeout(function() { $('.stockloading').hide(); 
                                         document.getElementsByClassName('stockloading')[0].style.display = "none"
                                        }, 1000);



                } else {

                  $('input[name="button"]')[0].value="stock épuisé"
                  $('input[name="button"]')[0].disabled = true
                  $('.flits-wsl-btn').hide();
                  setTimeout(function() { $('.stockloading').hide();
                                         document.getElementsByClassName('stockloading')[0].style.display = "none"
                                        }, 1000);
                  //	$('.stockloading').hide();


                } 


//               }else {

//                   $('input[name="button"]')[0].value="stock épuisé"
//                   $('input[name="button"]')[0].disabled = true
//                   $('.flits-wsl-btn').hide();
//                   setTimeout(function() { $('.stockloading').hide(); }, 1000);
//                   //	$('.stockloading').hide();


//                 }
            }else{
              $('.stockloading').hide();
              document.getElementsByClassName('stockloading')[0].style.display = "none"


            }

          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log(textStatus, errorThrown);
          $('.stock_loading').hide();
          document.getElementsByClassName('stockloading')[0].style.display = "none"

        }
      });
    });





    $(document).on('change', '#quantity', function() {
      console.log(this.value)

      $('.stock_loading').show();
      document.getElementsByClassName('stockloading')[0].style.display = "block"
      console.log("change")
      $('.variant__button-label').removeClass("disabled");
      console.log("variant change detected");
      var change_url = new URL(window.location.href);
      var var_id = change_url.searchParams.get("variant");
      var selectedvars = (var_id != undefined) ? var_id : meta.product.variants[0].id;
      var variant_quantity = this.value;
      console.log(var_id);
      $.ajax({
        url: appurl + "ajax_product_stock.php",
        type: "POST",
        data: { shop_name: shop_name, product_id: meta.product.id,variant_id: selectedvars, page: "product-change",variant_quantity:variant_quantity },
        dataType: "json",
        success: function(response) {
          console.log(response);

          if (response.result == 'true') {
            $('form[action="/cart/add"]').prepend('<div class="stockloading loader"></div>');
            $('form[action="/cart/add"]').prepend('<style>.stockloading.loader{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-image: url(https://q-france.appshq.io/images/loading-gear.gif);background-repeat: no-repeat;background-position: center;z-index: 10;background-color: white; display:none;}form[action="/cart/add"]{position:relative;}</style>');

            $('form[action="/en/cart/add"] .product-single__add').before('<div class="stockloading loader"></div>');
            $('form[action="/en/cart/add"] .product-single__add').before('<style>.stockloading.loader{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-image: url(images/loading-gear.gif);background-repeat: no-repeat;background-position: center;background-color: white; display:none;}form[action="/cart/add"]{position:relative;}</style>');

            $('.stock_loading').show();

            document.getElementsByClassName('stockloading')[0].style.display = "block"
            if(response.tag !== ""){



              if (response.meter_selected <= response.database_available) {
                $('.product-single__stock-note').show();
                $('input[name="button"]')[0].value="Ajouter au panier"
                $('input[name="button"]')[0].disabled = false
                $('.flits-wsl-btn').prop('disable', false);

                setTimeout(function() { 
                  $('.stockloading').hide(); 
                  document.getElementsByClassName('stockloading')[0].style.display = "none"
                }, 1000);



              } else {

                $('input[name="button"]')[0].value="stock épuisé"
                $('input[name="button"]')[0].disabled = true
                $('.flits-wsl-btn').hide();
                setTimeout(function() { 
                  $('.stockloading').hide(); 
                  document.getElementsByClassName('stockloading')[0].style.display = "none"
                }, 1000);


              }
            }else{
              $('.stockloading').hide();
              document.getElementsByClassName('stockloading')[0].style.display = "none"


            }

          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log(textStatus, errorThrown);
          $('.stock_loading').hide();
          document.getElementsByClassName('stockloading')[0].style.display = "none"

        }
      });
    });




  }

  if(meta.page.pageType == 'home'){

    var products=[];
    $(".sc-gzcbmu").each(function(){
      var product_id=$(this).attr("data-product-id");
      products.push(product_id);
    });
    console.log("Products are : ",products)
    var my_products = JSON.stringify(products);

    $.ajax({
      url: appurl + "ajax_home_products.php",
      type: "POST",
      data: { shop_name: shop_name, product_id: my_products,page:meta.page.pageType},
      dataType: "json",
      success: function(response) {
        console.log(response)
        $.each(response.result,function(index,value){


          if(value.tag !== ""){
            console.log("Tag Hy")

            if (value.meter_selected <= value.database_available) {

              $('button[data-product-id='+value.pid+']').html("Ajouter au panier")
              $('button[data-product-id='+value.pid+']').prop('disabled', false);

              setTimeout(function() { $('.stockloading').hide(); }, 1000);



            } else {

              $('button[data-product-id='+value.pid+']').html("stock épuisé");
              $('button[data-product-id='+value.pid+']').prop('disabled', true);
              setTimeout(function() { $('.stockloading').hide(); }, 1000);

              //	$('.stockloading').hide();


            }

          }else{
            console.log("Tag Nai Hy")
            setTimeout(function() { $('.stockloading').hide(); }, 1000);
            //	$('.stockloading').hide();

          }
        });



      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus, errorThrown);
      }
    });


  }

});